// Routes that are EXCLUSIVE to Agent view
// Navigating to these switches to Agent mode
export const AGENT_EXCLUSIVE_ROUTES = [
  'home',
  'agents',
  'tests',
  'test-management',
  'playwright/history',
  'projects',
  'cloud',
  'playwright/schedulers',
  'test-config',
  'cli-sessions',
  'environments',
] as const;

// Routes that are SHARED between both views
// These preserve the current view mode
export const SHARED_ROUTES = ['testData', 'settings', 'pr'] as const;
